/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tickets_List_TitleInputs */

const nl_tickets_list_title = /** @type {(inputs: Tickets_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mijn tickets`)
};

/**

* @param {Tickets_List_TitleInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const tickets_list_title = /** @type {((inputs?: Tickets_List_TitleInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tickets_List_TitleInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_tickets_list_title(inputs)
});
export { tickets_list_title as "tickets.list.title" }